import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import MultiSelectFormField from 'src/registry/components/forms/MultiSelectFormField';
import { Form } from 'src/registry/ui/Form';
import { CreateUserFormSchemaValues } from 'src/features/users/utils/formSchema';
import { useListRoles } from 'src/features/roles/api/useListRoles';
import { userMessages } from 'src/features/users/utils/messages';

type UserFormProps = {
    form: UseFormReturn<CreateUserFormSchemaValues>;
    onSubmit: (values: CreateUserFormSchemaValues) => void;
};

function CreateUserForm({ onSubmit, form }: UserFormProps) {
    const { formatMessage } = useIntl();

    const { data } = useListRoles({});

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<CreateUserFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(userMessages.name)}
            />
            <InputFormField<CreateUserFormSchemaValues>
                form={form}
                name="username"
                label={formatMessage(userMessages.username)}
            />
            <InputFormField<CreateUserFormSchemaValues>
                form={form}
                name="email"
                label={formatMessage(userMessages.email)}
            />
            <MultiSelectFormField<CreateUserFormSchemaValues>
                form={form}
                name="roles"
                label={formatMessage(userMessages.roles)}
                options={data?.results}
            />
            <InputFormField<CreateUserFormSchemaValues>
                form={form}
                name="password"
                type="password"
                label={formatMessage(userMessages.password)}
            />
            <InputFormField<CreateUserFormSchemaValues>
                form={form}
                name="password_confirm"
                type="password"
                label={formatMessage(userMessages.confirmPassword)}
            />
        </Form>
    );
}

export default CreateUserForm;
